<template>
  <div class="content--sinoreg p-3 print">
    <header class="headerBlue">
      <h4 class="resumo-show_title pl-2 mt-3">
        <span class="pt-3 resumo-show_title-label">
          Frente de Caixa: {{ dataAdaptada }}
        </span>
      </h4>
    </header>
    <ModalFechamentoCaixa v-if="caixaStore.aberto === true || caixaStore.aberto == 1" />
    <sub-header-grey class="p-3 mt-3">
      <label class="label">OS/Pedido</label>
    </sub-header-grey>

    <div class="d-flex justify-content-center">
      <table class="table w-100 mt-5 ml-5 mr-5">
        <thead class="aling-itens-center">
          <tr class="table-header">
            <th class="col-1">
              OS/Pedido
            </th>
            <th class="col-2">
              Data
            </th>
            <th class="col-3">
              Solicitante
            </th>
            <th class="col-2">
              Forma de pg
            </th>
            <th class="col-2">
              Tipo pg
            </th>
            <th class="col-2">
              Valor
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="os in pedidos.os.lista"
              :key="os.cx_pedido_id"
              class="table-linha">
            <th scope="row">
              {{ os.ordemServico.numero }}
            </th>
            <td>
              {{ os.created_at | date }}
            </td>
            <td>
              {{ os.solicitante }}
            </td>
            <td>
              <span :id="`recebimento-avulso-tooltip${os.cx_pedido_id}`">
                {{ os.parcelas.length > 1 ? 'Diversas' : os.parcelas[0].forma_pg }}
                <b-badge v-if="os.parcelas.length > 1"
                         variant="light">
                  {{ os.parcelas.length }}
                </b-badge>
                <icon-svg v-show="os.parcelas.length > 1"
                          icon="helpCircle"
                          class="icon--sm icon ml-2"
                          style="fill: #074f7f !important;" />
              </span>
              <b-tooltip v-if="os.parcelas.length > 1"
                         :target="`recebimento-avulso-tooltip${os.cx_pedido_id}`"
                         triggers="hover">
                <div v-for="(parcela, index) in os.parcelas"
                     :key="index">
                  <div class="d-flex justify-content-between">
                    <span class="mr-1">{{ parcela.forma_pg }}</span>
                    <span>{{ parcela.valor | moneyToString }}</span>
                  </div>                  
                </div>
              </b-tooltip>
            </td>
            <td>
              {{ os.parcelas[0].tipo_pg }}
            </td>
            <td>
              <input v-money="money"
                     :value="os.ordemServico.valor_total"
                     disabled
                     class="w-100"
                     name="custa_ipesp"
                     size="sm"
                     trim>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <sub-header-grey class="p-3 mt-3">
      <label class="label">Recebimento avulso</label>
    </sub-header-grey>

    <div class="d-flex justify-content-center">
      <table class="table w-100 mt-5 ml-5 mr-5">
        <thead class="aling-itens-center">
          <tr class="table-header">
            <th class="col-2">
              Data
            </th>
            <th class="col-3">
              Tipo de serviço
            </th>
            <th class="col-2">
              Qdt
            </th>
            <th class="col-2">
              Forma de pg
            </th>
            <th class="col-2">
              Valor
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in pedidos.avulsos.lista"
              :key="item.cx_pedido_id"
              class="table-linha">
            <td>
              {{ item.created_at | date }}
            </td>
            <td>
              {{ item.lancamentosAvulso.detalhamento }}
            </td>
            <td>
              1
            </td>
            <td>
              <span :id="`recebimento-avulso-tooltip${item.cx_pedido_id}`">
                {{ item.parcelas.length > 1 ? 'Diversas' : item.parcelas[0].forma_pg }}
                <b-badge v-if="item.parcelas.length > 1"
                         variant="light">
                  {{ item.parcelas.length }}
                </b-badge>
                <icon-svg v-show="item.parcelas.length > 1"
                          icon="helpCircle"
                          class="icon--sm icon ml-2"
                          style="fill: #074f7f !important;" />
              </span>
              <b-tooltip v-if="item.parcelas.length > 1"
                         :target="`recebimento-avulso-tooltip${item.cx_pedido_id}`"
                         triggers="hover">
                <div v-for="(parcela, index) in item.parcelas"
                     :key="index">
                  <div class="d-flex justify-content-between">
                    <span class="mr-1">{{ parcela.forma_pg }}</span>
                    <span>{{ parcela.valor | moneyToString }}</span>
                  </div>                  
                </div>
              </b-tooltip>
            </td>
            <td>
              <input v-money="money"
                     :value="item.ordemServico ? item.ordemServico.valor_total :
                       item.lancamentosAvulso ? item.lancamentosAvulso.valor_total : ''"
                     disabled
                     class="w-100"
                     size="sm"
                     trim>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <sub-header-grey class="p-3 mt-3">
      <label class="label">Despesas</label>
    </sub-header-grey>

    <div class="d-flex justify-content-center">
      <table class="table w-100 mt-5 ml-5 mr-5">
        <thead class="aling-itens-center">
          <tr class="table-header">
            <th class="col-2">
              Data
            </th>
            <th class="col-3">
              Tipo de serviço
            </th>
            <th class="col-2">
              Forma de pg
            </th>
            <th class="col-2">
              Valor
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in pagamentosAvulso.lista"
              :key="item.cx_lancamento_id"
              class="table-linha">
            <td>
              {{ item.created_at | date }}
            </td>
            <td>
              {{ item.detalhamento }}
            </td>
            <td>
              ---
            </td>
            <td class="valor-pagamentos">
              <input v-money="money"
                     :value="item.valor_total"
                     disabled
                     class="w-100"
                     name="custa_ipesp"
                     size="sm"
                     trim>
            </td>
          </tr>
        </tbody>
      </table>
    </div> 
    <Cards class="m-5 d-flex justify-content-between"
           prop-componente-pai="FechamentoFrenteDeCaixa" />
    <div class="saldo-container">
      <div class="saldo-infos">
        <span class="saldo-infos-total">Total</span>
        <input v-model="valorTotalPedidos"
               v-money="money"
               disabled
               class="saldo-infos-valor"
               name="valor-pedido"
               size="sm"
               trim>
      </div>
      <div class="saldo-botoes">
        <b-button class="saldo-botao-voltar"
                  @click="voltar">
          Voltar
        </b-button>
        <b-button class="saldo-botao-imprimir"
                  @click="imprimir()">
          Imprimir
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment'
  import { VMoney } from 'v-money'

  // components
  import SubHeaderGrey from '../../../../components/SofiaRei/Headers/SubHeaderGrey.vue'
  import Cards from '../FrenteDeCaixaConcluidos/Orcamentos/Cards/Cards.vue'
  import ModalFechamentoCaixa from './ModalFechamentoCaixa.vue'
  import ModalReaberturaCaixa from '../Abertura/ModalReaberturaCaixa.vue'

  // Services
  import pedidoService from '../pedidoService'
  import CartorioService from "@/services/CartorioService"
  import caixaService from '../caixaService'

  // utils
  import {moneyToNumber} from '../../../../utils/conversors'

  export default {
    name: "FechamentoFrenteDeCaixa",
    directives: {
      money: VMoney
    },
    components: {    
      SubHeaderGrey,
      Cards,
      ModalFechamentoCaixa,
      ModalReaberturaCaixa
    },
    data () {
      return {
        pedidos: {    
          os: [],
          avulsos: [],
        },
        cartorio: null,
        pagamentosAvulso: [],
        tipoPg: [],
        formaPg: [],
        valorTotalPedidos: 0,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    computed: {
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
    },
    async created () {
      // Mapeia saldo atual para data vue
      this.dataAdaptada = moment(this.cxData, 'YYYY-MM-DD').format('DD-MM-YYYY')
      this.pedidos.os = this.cxSaldo.pedidos.os
      this.pedidos.avulsos = this.cxSaldo.pedidos.avulsos
      this.pagamentosAvulso = this.cxSaldo.pagamentosAvulso
      this.tipoPg = this.cxSaldo.tipoPg
      this.formaPg = this.cxSaldo.formaPg
      this.valorTotalPedidos = this.cxSaldo.pedidos.saldoTotal

      const { data } = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
      this.cartorio = data
    },
    methods: {
      async imprimir () {
        moment.locale('pt-br')
        // ajusta formato da data para enviar ao server
        this.pedidos.os.lista.forEach(pedido => {
          pedido.created_at = moment(pedido.created_at, 'YYYY-MM-DD')
            .format('DD-MM-YYYY')
        })
        this.pedidos.avulsos.lista.forEach(pedido => {
          pedido.created_at = moment(pedido.created_at, 'YYYY-MM-DD')
            .format('DD-MM-YYYY')
        })
        this.pagamentosAvulso.lista.forEach(pedido => {
          pedido.created_at = moment(pedido.created_at, 'YYYY-MM-DD')
            .format('DD-MM-YYYY')
        })
        // Formata escrita do dia para colocar primeira letra em maiusculo
        let diaExtenso = moment(this.cxData, 'YYYY-MM-DD').format('dddd')
        diaExtenso = diaExtenso[0].toUpperCase() + diaExtenso.substring(1)

        const  payload = {
          os: this.pedidos.os,
          avulsos: this.pedidos.avulsos,
          pagamentosAvulso: this.pagamentosAvulso,
          tipoPg: this.tipoPg,
          formaPg: this.formaPg,
          total: this.valorTotalPedidos,
          dataCx: moment(this.cxData, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          diaExtenso,
          caixa: this.caixaStore,
          cartorio: this.cartorio
        }
        try {
          loader({text: 'Gerando PDF', active: true})
          const url = await pedidoService.getPdfRelatorio(payload)
          window.open(url)
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }       
        
      },
      voltar () {
        window.history.back()
      },
      async fecharCaixa () {
        const payload = {
          caixa: this.caixaStore,
          saldoFinal: moneyToNumber(this.valorTotalPedidos)
        }
        await caixaService.fecharCaixa(payload)
      }
    },
  }

</script>

<style lang="scss" scoped>
  @import "../../../../scss/_utilities/_variables";

  .headerBlue{
    background-color: $sinoreg-blue;
    color: $color-white;
    fill: $color-white;
    padding: pxToRem(8);
    font-size: pxToRem(20);
    font-weight: 500;
    height: 100%;
    width: 100%;
  }
  .table-header {
  font-weight: bold;
  padding: 10px;
  background-color: #00C0A7;
  font-size: 18px;
}
  .table-linha {
    padding: 10px 0px;  
    border: solid 1px #cacbcb;
    transition: .3s;
    }
input:disabled {
    padding: 0;
    text-align: left;
    color: black;
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
    background: transparent;
}
  .label {
    font-size: 24px;
  }
  .valor-pagamentos input {
    padding: 0;
    text-align: left;
    color: red;
  }
  .saldo-container {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  .saldo-infos {
    display: flex;
    justify-content: space-between;
    min-width: 50%;
    padding: 10px 20px;
    background-color: #cacbcb;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .saldo-infos-total{
    font-size: 26px;
  }
  .saldo-infos input {
    font-size: 28px;
    text-align: right;
    font-weight: bold;
  }
  .saldo-botoes {
    display: flex;
    gap: 20PX;
  }
  .saldo-botao-imprimir {
    min-width: 120px;
    font-size: 18px;
  }
  .saldo-botao-voltar {
    background-color: #cacbcb;
    border: #cacbcb;;
    color: black;
    min-width: 100px;
    font-size: 18px;
  }
  .icon {
      width: 20px;
    }
</style>